import { isStoreBuild } from './platform';

/**
 * Запрет «щипка» в приложении из магазина.
 *
 * ЗАЧЕМ. Заказчик 22.08.2026: «листаешь, куда-то нажимаешь — и экран зумится».
 * В нативном приложении масштабирование страницы выглядит поломкой: у настоящих
 * приложений экран не «уезжает», и вернуть его обратно человек не всегда
 * догадывается — остаётся сидеть в перекошенном интерфейсе.
 *
 * ⚠️ ПОЧЕМУ НЕ ПРОСТО ПРАВКА В index.html. Тот же файл открывается в браузере,
 * а там запрет масштабирования — это уже вред: человек со слабым зрением
 * приближает страницу, и отнимать у него эту возможность нельзя (в вебе это
 * прямо считается нарушением доступности). Поэтому запрет ставится ТОЛЬКО в
 * приложении и только во время работы.
 *
 * Интерфейс от этого не становится мельче: у нас всё и так рассчитано на
 * телефон, а системный размер шрифта продолжает действовать.
 */
export function lockViewport(): void {
  if (!isStoreBuild()) return;
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  meta.setAttribute(
    'content',
    'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover',
  );
  // Safari на iOS до сих пор умеет масштабировать двойным касанием даже при
  // user-scalable=no, поэтому гасим ещё и жест приближения двумя пальцами.
  document.addEventListener('gesturestart', (e) => e.preventDefault());
}
